/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2021.

!Changelog

2021
	27-03-2021 
	- [BUILD] This class is born, hooray!

!Usage
	
	windowAction.onready();
	
!Wishlist

	No wishes
 
*/
  
var specific_videoplayer = {};

(function(){
	
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************

	this.onready = function() {
		
		$(document).on('click','.js-videoplayer-play',function() {
			specific_videoplayer.play();
		});
		
	};
	
	// FUNCTIONS *****************************************************************
	// FUNCTIONS *****************************************************************
	// FUNCTIONS *****************************************************************
	// FUNCTIONS *****************************************************************
	
	this.play = function() {

		var _video_str = '<video src="' + globalUrl + '/doc/temp/digidag-explainer.mp4" autoplay controls loop></video>';
		
		$('.js-videoplayer').html(_video_str);

		/*
		Hide button
		*/
		$('.js-videoplayer-play').hide();
		
	};

}).apply(specific_videoplayer); 